module.exports = __webpack_public_path__ + "static/sobre-top-screens-331477e6e9a942ea720243cbce46fcd2.png";